var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-select", {
    attrs: {
      multiple: _vm.type == 1,
      filterable: "",
      placeholder: "请选择",
      clearable: ""
    },
    model: {
      value: _vm.label,
      callback: function callback($$v) {
        _vm.label = $$v;
      },
      expression: "label"
    }
  }, _vm._l(_vm.goodsArray, function (item) {
    return _c("el-option", {
      key: item.goodsId,
      attrs: {
        label: item.goodsId + item.goodsName,
        value: item.goodsId
      }
    });
  }), 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };